import { Card, Skeleton, Space } from '@sravni/react-design-system';

import styles from './RightPart.module.scss';
import { SkeletonCard } from './SkeletonCard';

export const RightPartSkeleton = () => {
  return (
    <Space
      size={32}
      direction="vertical"
    >
      <Card>
        <Space
          size={16}
          direction="vertical"
        >
          <Space
            size={16}
            justify="space-between"
            align="center"
          >
            <Space
              size={16}
              align="center"
            >
              <Skeleton.Avatar
                inverted
                className={styles.avatar}
              />
              <Skeleton.Paragraph
                inverted
                width={60}
                className={styles.title}
              />
            </Space>
            <Skeleton.Paragraph
              inverted
              className={styles.button}
            />
          </Space>

          {[1, 2, 3, 4, 5, 6].map((item) => {
            return <SkeletonCard key={item} />;
          })}
        </Space>
      </Card>
      <Card>
        <Space
          size={16}
          direction="vertical"
        >
          <Space
            size={16}
            align="center"
          >
            <Skeleton.Avatar
              inverted
              className={styles.avatar}
            />
            <Skeleton.Paragraph
              inverted
              width={60}
              className={styles.title}
            />
          </Space>
          <Space>
            <Skeleton.Paragraph
              inverted
              width={30}
              className={styles.h36}
            />
            <Skeleton.Paragraph
              inverted
              width={20}
              className={styles.h36}
            />
            <Skeleton.Paragraph
              inverted
              width={40}
              className={styles.h36}
            />
          </Space>
          {[1, 2, 3, 4, 5, 6].map((item) => {
            return <SkeletonCard key={item} />;
          })}
        </Space>
      </Card>
    </Space>
  );
};
